// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U4: КАРТА ОБЪЯСНЕНИЙ ОБЛАСТИ «chips» (чипсы шапки стола
// и таблиц, их формы по наведению, панель ⌄ и её команды) — handoff-files/ui-help-2026-09-24/spec-chips.json (147 ключей / 99 якорей
// в src/components/widgets/components_core/AttrChips.vue). Тексты — английские литералы в t() (словари uk.json / ru.json), поле setting —
// техническое имя настройки/консоли — НЕ переводится (как и в картах menuPanel/topbarNav). Помощники выбора ключа для
// общих якорей (chip → 25 видов, вкладки/строки ⌄, кнопки Commands) — uiHelp_chipKind / uiHelp_ddTabKey / uiHelp_ddItemKey / uiHelp_cmdKey,
// методы AttrChips.vue (код — в p186_u4_chips.py). Подстановка {name} в этой области НЕ НУЖНА — в текстах спеки ни одного {…}.
import { t } from '@/i18n'

// виды чипсов (AttrChips.uiHelp_chipKind), которые Backspace в пустом поле поиска не снимает: у полосы шапки поля ввода нет, виртуальные чипсы
// над таблицей removeLastChip пропускает (дефект Backspace / Corrections, U4)
const CHIPS_NO_BACKSPACE = ['selector', 'period', 'metric-global', 'metric-mirror', 'corrections', 'unsaved-edits', 'info', 'schedule-paused', 'compare', 'process-model', 'limit', 'widgets-page']   // IE 2026 10 10 / ODOO-345813: + schedule-paused


// IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице): кнопки группы Page на ВРЕМЕННОЙ странице (плитка «+» рейла, записи PAGE ещё нет) —
// состояние temp (AttrChips.uiHelp_cmdState): «+» и «✓» сохраняют саму страницу (как ⧉ «Save as new page»), ⚙ недоступна
function tempPageHelp(kind) {
    const click = t('Click — enter a title; the page is saved, added at the end of the page list and opens under its title.')
    const now = t('This page is new and not saved yet — it has no record.')
    const why = t('Keep the page you have just built.')
    const stored = t('On the server: a new Page record and the updated workspace record.')
    switch (kind) {
        case 'new': return {
            title: t('Save the new page'),
            what: t('This page is new and not saved yet — it has no record, so there is nothing to make a variant of: «+» saves the page itself as a page of the workspace, with the open widgets and their layout.'),
            why, click, now,
            affects: t('The new page appears in the page list of the workspace for all its users; after that «+» makes variants of it as usual.'),
            stored,
        }
        case 'save': return {
            title: t('Save the page'),
            what: t('This page is new and not saved yet — there is no page record to save into: «Save» saves it as a page of the workspace, with the open widgets and their layout.'),
            why, click, now,
            affects: t('The new page appears in the page list of the workspace for all its users.'),
            stored,
        }
        case 'settings': return {
            title: t('Page settings'),
            what: t('Opens the record of the current page — this page is new and not saved yet, it has no record, so the button is unavailable.'),
            why: t('Change the page itself.'),
            click: t('Unavailable until the page is saved: save it with «+», «✓» or «Save as new page» — then its settings open here.'),
            now,
        }
        case 'copy': return {
            title: t('Save as new page'),
            what: t('Saves this new page (not saved yet) as a page of the workspace — the open widgets and their layout as they are.'),
            why, click, now,
            affects: t('The new page appears in the page list of the workspace for all its users.'),
            stored,
        }
    }
    return null
}

const chips = {
    // Workspace chip strip — AttrChips.vue:2
    'chips.strip.page': () => ({
        title: t('Workspace chips'),
        what: t('Filters of the whole workspace: each chip narrows what the page widgets show (objects, countries, period, metrics…).'),
        why: t('One place to see and change the data the workspace works with.'),
        click: t('Point at a chip to open its form; the ⌄ button opens the list of all filters and the Commands. On a phone a tap on the strip opens that list.')
            + ' ' + t('A right-click on a chip opens its form at once.'),   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — рейл / чипс / стол)
        affects: t('Widgets of the page that take the workspace selectors re-read their data after every change; other pages catch up when you open them.'),
        stored: t('Only for you: in this tab and as a snapshot in this browser, restored when you reopen the workspace (a link with filters wins). Others get them only when they are saved into the workspace or into a shared filters variant.'),
        setting: 'fe.appearance.chipsBarPosition',
    }),
    // Table chip strip — AttrChips.vue:2
    'chips.strip.grid': () => ({
        title: t('Table chips'),
        what: t('Chips of this table only: search texts, filters, metrics and formatting selections, grouping, hierarchy and sorting.'),
        why: t('To find and narrow rows here without touching the workspace filters.'),
        click: t('Click the empty part of the strip and type, Enter adds a search chip; point at a chip to open its form; ⌄ offers ready-made chips (Parent, Metrics, Formats).')
            + ' ' + t('A right-click on a chip opens its form at once.'),   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — рейл / чипс / стол)
        affects: t('Only this widget: chips work on the loaded rows, except chips set to Input — those make the server re-read the data.'),
        stored: t('With this widget\'s settings: in this tab while the widget is open, and in the setting itself once you save the widget (then everyone who opens it gets them).'),
        setting: 'viewParams.<table>.hideCHIPS',
    }),
    // Search icon of an empty strip — AttrChips.vue:10
    'chips.search-icon': () => ({
        title: t('Search'),
        what: t('Shown while the strip has no chips.'),
        why: t('Marks where a table search is typed.'),
        click: t('Table: click — the search field appears with the cursor in it. Header: on a phone it opens the ⌄ list; on a computer there is nothing to type here — use ⌄.'),
        affects: t('Nothing by itself.'),
        states: { 'header': t('Header strip: nothing to type here on a computer.'), 'table': t('Table strip: click to type a search.') },
    }),
    // Placeholder text — AttrChips.vue:372
    'chips.placeholder': () => ({
        title: t('Placeholder'),
        what: t('A hint in an empty chip field, for example in a chat.'),
        click: t('Click the strip to start typing.'),
    }),
    // Search field — AttrChips.vue:374
    'chips.input': () => ({
        title: t('Search field'),
        what: t('The text you type becomes a search chip; if you continue in another keyboard layout, the letters already typed are re-typed in it.'),
        why: t('Quick search across the rows of this table.'),
        click: t('Enter — add the text as a search chip; Backspace in an empty field — remove the last chip you added (information chips such as Corrections stay); Esc — clear the text (in an empty field Esc goes to the widget and usually closes it). Pasting a copied chip, a file or a picture adds it as a chip.'),   // U4: после починки removeLastChip (виртуальные чипсы Backspace не снимает)
        affects: t('While you type (after a short pause), this table highlights and counts the matches without hiding any rows; the typed text stays active when you click elsewhere until you erase it or press Esc. The chip made by Enter filters and highlights the rows (by default it keeps rows without matches visible).'),   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска): живой поиск при наборе, Enter — чипс
        stored: t('Nothing until you press Enter.'),
        hotkey: t('Enter · Backspace · Esc · Ctrl+V'),
    }),
    // webscm 2026 11 02 / ODOO-350849 (заказ Андрея: как скопировать и как вставить в поле вложений чата): то же поле чипсов в LLM-чате — AttrChat.vue (attr.uiHelp); только то, что работает:
    // вставка — onPaste, чипс уходит с msg_send, а без текста сообщение не отправляется (canSend); Ctrl+C таблицы — текст (onPaste кладёт его в строку поиска), чипс данных — Alt+C (copyItems).
    // 50 КБ — MAX_CHIP_TEXT бэка (llm_worker): замер на отчёте Demo7, Alt+C по 15 ячейкам: doc.data 2,6 КБ и doc.cells 1,2 КБ идут первыми и доходят, срезается doc.fields (652 КБ, описание колонок)
    'chips.input.chat': () => ({
        title: t('Attachments to the message'),
        what: t('Paste a screenshot or a copied table area here: it becomes a chip and goes with your next message.'),
        how: t('Screenshot: Win+Shift+S on Windows, Ctrl+Shift+Cmd+4 on a Mac. Table area: select the cells and press Alt+C (Option+C on a Mac), whole rows are copied. Ctrl+C in a table gives plain text, which stays in this field as search text: paste such text into the message box.'),
        click: t('Click this field, then press Ctrl+V (Cmd+V on a Mac). Type your question in the message box and press Enter: without text nothing is sent.'),
        affects: t('A copied table area reaches the assistant only up to 50 KB: select just the rows you need.'),
        hotkey: t('Alt+C · Ctrl+V · Cmd+V'),
    }),
    // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p194 глобальна форма чіпів — поле пошуку за всіма селекторами, копіювання чіпа в інший стіл): поле поиска полосы чипсов стола — AttrChips.vue (barSearch_*)
    'chips.bar.input': () => ({
        title: t('Search by selectors'),
        what: t('Type a name — the search runs over the values of all selectors of this workspace at once.'),
        why: t('Turn on a selector chip without opening each selector.'),
        click: t('Type at least two letters; ↑ ↓ — move through the list, Enter — turn on the highlighted value (the first one if none is highlighted), Esc — clear the text. Ctrl+V of a copied chip (a click on a chip copies it) turns that chip on in this workspace.'),   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p194 глобальна форма чіпів — поле пошуку за всіма селекторами, копіювання чіпа в інший стіл): вставка скопированного чипса
        affects: t('If nothing matches exactly, values with typos or an extra symbol are shown, as in the chip form. The chosen value becomes the selector chip, and the workspace is filtered by it.'),
        stored: t('In the workspace memory until the workspace is saved.'),
        setting: 'fe.ux.chipsBarInput · fe.ux.chipsBarSearchLimit · fe.ux.chipsBarMaxRows · fe.ux.chipsBarMaxSegments · fe.ux.chipsBarMaxBytes · fe.ux.chipsBarServerLimit · fe.ux.chipsBarCopy · fe.ux.chipsBarCopyOnClick · fe.ux.topBarCompact',   // IE 2026 11 04 / ODOO-350449 (заказ Игоря: верхняя полоса в один ряд — иконки вместо подписей, «⋯» вместо поиска): при чипсах поле — «⋯»   // IE 2026 11 02 / ODOO-350449 (дефект боя webscm #125565 по p194: p213 — словники лише при наборі, ліміт, серверний пошук для великих сегментів)   // IE 2026 11 02 / ODOO-350449 (p213b: вид джерела і розмір сегмента у словнику SEGMENTS, LIMIT у name_search): + fe.ux.chipsBarMaxBytes
        // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p194 глобальна форма чіпів — поле пошуку за всіма селекторами, копіювання чіпа в інший стіл)
        hotkey: t('↑ · ↓ · Enter · Esc · Ctrl+V'),
    }),
    'chips.bar.item': () => ({
        title: t('Selector value'),
        what: t('A value found in the selector named above it; the highlighted part matches the typed text.'),
        click: t('Click — turn on this value in the selector chip.'),
        affects: t('The workspace is filtered by the selector, as when the value is picked in the chip form.'),
    }),
    // Chip list and commands button (⌄) — AttrChips.vue:389
    'chips.dropdown-button': () => ({
        title: t('Chip list and commands'),
        what: t('Opens a panel: in the header — Selectors (all workspace filters with on/off boxes), Params and Commands (filter and page variants); above a table — ready-made chips (Parent, Metrics, Formats) and Params.'),
        why: t('To switch filters on and off, add a metrics chip and manage saved variants.'),
        click: t('Click — open or close the panel; a click outside it or switching to another widget closes it.'),
        affects: t('Nothing until you act in the panel.'),
        states: { 'open': t('The panel is open.'), 'closed': t('The panel is closed.') },
    }),
    // Chip — AttrChips.vue:15
    'chips.chip': () => ({
        title: t('Chip'),
        what: t('A condition or a setting shown as a chip; the icon on the left shows its kind.'),
        why: t('Keeps active filters and searches visible and easy to change.'),
        click: t('Point — its form opens after a short pause; click — select it; drag — move it within the strip or to another chip strip.'),
        affects: t('Depends on the kind of chip.'),
        stored: t('Header chips — for you in this browser; table chips — with the widget settings.'),
        setting: 'fe.ux.hoverOpenMs · fe.ux.hoverHideMs',
        hotkey: t('Ctrl+C · Ctrl+X · Esc (selected chip)'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Workspace filter chip — AttrChips.vue:15
    'chips.chip.selector': () => ({
        title: t('Workspace filter'),
        what: t('Filters the workspace by one field, for example Object or Country: the field name, then the selected values (the number in brackets is how many).'),
        why: t('Narrows the data of all widgets that take the workspace selectors.'),
        click: t('Point — the form with the values; click — for a field with a value list the form opens at once with the cursor in «Pick another value…»; double-click — open the selector widget that set this filter.'),
        affects: t('Widgets that take this field re-read their data; other pages catch up when you open them.'),
        stored: t('Only for you: in this tab and in this browser\'s snapshot of the workspace chips.'),
        setting: 'window.chipsKeep.set(\'enabled\', false)',
        hotkey: t('Ctrl+C · Ctrl+X · Esc (selected chip)'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Period chip — AttrChips.vue:15
    'chips.chip.period': () => ({
        title: t('Period'),
        what: t('The workspace period from … to …; whole months are shown as 2026-12, a whole year as 2026.'),
        why: t('Limits the dates shown by the widgets that use the period.'),
        click: t('Point — the form with From / To dates; a range picked on the chart that sets the period lands here; double-click — open that chart widget.'),
        affects: t('Only the widgets that use the period re-read (on other pages — when you open them); selector lists are not touched.'),
        stored: t('Only for you: in this tab and this browser\'s snapshot; an empty period is filled at opening from the fact date to the end of the planning horizon.'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Workspace metrics chip — AttrChips.vue:15
    'chips.chip.metric-global': () => ({
        title: t('Metrics chip (workspace)'),
        what: t('Selects problems by metric marks: Grade, Metric, Horizon, Status or exact combinations of them.'),
        why: t('To look at the whole workspace through one kind of problem, for example all «Bad» cases.'),
        click: t('Click or point — the form with lists and search; the icon on the left opens the metrics report the chip is resolved through.'),
        affects: t('Widgets set to Input (the default for widgets without their own metrics) get only the calculation nodes with these metrics; widgets with their own metrics show a read-only copy above the table; a change is sent after a short pause.'),
        stored: t('Only for you: in the workspace chips of this tab and this browser; Recent selections — in this browser.'),
        setting: 'fe.ux.metricChipGlobal · fe.ux.metricChipGlobalDelayMs',
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Copy of the workspace metrics chip — AttrChips.vue:15
    'chips.chip.metric-mirror': () => ({
        title: t('Workspace metrics chip (copy)'),
        what: t('A read-only copy of the metrics chip from the workspace header; shown because this table takes that chip as a Table chip.'),
        why: t('Shows which rows and cells of this table have the selected metrics, with a counter and navigation.'),
        click: t('Point — see the selection and the switches «Show rows without matches» / «Show other formatting»; change the selection itself in the header; ‹ › — go through the cells.'),
        affects: t('Only this table; it appears only when the table knows at least one of the selected metrics, and it gives way to the table\'s own metrics chip.'),
        stored: t('Not saved: it follows the header chip; the switches live in this tab.'),
        setting: 'fe.ux.metricMirrorKnownOnly',
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Search chip — AttrChips.vue:15
    'chips.chip.search': () => ({
        title: t('Search chip'),
        what: t('Looks for the text in this table: several words are first searched as a whole phrase, otherwise each word anywhere in the row; if nothing is found, the other keyboard layout and then typos are tried.'),
        why: t('Quickly find rows and cells without writing a filter.'),
        click: t('Point — the form (Show rows without matches, Table | Input); double-click the text — edit it; ‹ › — go through the found cells.'),
        affects: t('Hides rows without matches and highlights the found text in this table; set to Input, the server searches the selection instead.'),
        stored: t('With this widget\'s settings in this tab; kept in the setting if you save the widget.'),
        setting: 'fe.ux.searchPhraseFirst · fe.grid.searchNavMaxRows · fe.ux.exprChipStrictTree',   // IE 2026 10 31 / ODOO-349799: чипс-выражение «= row.<поле>» отбирает дерево строго
        hotkey: t('Double-click — edit'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Filter chip — AttrChips.vue:15
    'chips.chip.filter': () => ({
        title: t('Filter chip'),
        what: t('A condition on the fields of this table, for example «Replenishment cycle is empty».'),
        why: t('Keeps only the rows that meet the condition.'),
        click: t('Point — the form with the condition and «Acts on»; the icon — open the chip settings with its conditions.'),
        affects: t('Input (default) — the server re-reads the selection with the condition; Table — only the loaded rows are filtered.'),
        stored: t('With this widget\'s settings in this tab; kept in the setting if you save the widget.'),
        setting: 'fe.ux.chipPlace',
        hotkey: t('Alt+F1 — chip settings (selected chip)'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Metrics chip of a table — AttrChips.vue:15
    'chips.chip.metric': () => ({
        title: t('Metrics chip (table)'),
        what: t('Selects rows and cells of this table by metric marks: Grade, Metric, Horizon, Status or exact combinations.'),
        why: t('To see only the problems you need, for example low stock in one horizon.'),
        click: t('Point — the form with lists, counters, search and Recent, and the matching cells get a frame; ‹ › — go through them.'),
        affects: t('Only this table: without «Show rows without matches» other rows are hidden (a tree keeps matching rows and their parents); cells painted by other rules are dimmed.'),
        stored: t('With this widget\'s settings in this tab; Recent — in this browser.'),
        setting: 'fe.ux.metricChip · fe.ux.metricChipStrictTree · fe.ux.metricChipCellNav',
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Formatting chip — AttrChips.vue:15
    'chips.chip.format': () => ({
        title: t('Formatting chip'),
        what: t('Selects rows and cells painted by the chosen conditional formatting rules (rules marked Selector in the Conditional format grid).'),
        why: t('To see where a formatting rule fires.'),
        click: t('Point — the form with the rules, counters rows · cells, search and Recent; the painted cells get a frame; ‹ › — go through them.'),
        affects: t('Only this table: without «Show rows without matches» rows without these rules are hidden; other formatting is dimmed, or hidden when «Show other formatting» is off.'),
        stored: t('With this widget\'s settings in this tab; Recent — in this browser.'),
        setting: 'fe.ux.formatChip',
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Styles chip — AttrChips.vue:15
    'chips.chip.style': () => ({
        title: t('Styles chip'),
        what: t('Selection by named styles («Styles: ■ …»), made on the Styles tab of the table.'),
        why: t('Shows the rows and cells with the chosen colours.'),
        click: t('Point — the form; ‹ › — go through the cells with these styles.'),
        affects: t('Rows without these styles are hidden (unless «Show rows without matches») and other data cells are dimmed.'),
        stored: t('With this widget\'s settings in this tab; kept in the setting if you save the widget.'),
        setting: 'fe.ux.gridStyleFilterDim',
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Hierarchy chip — AttrChips.vue:15
    'chips.chip.tree': () => ({
        title: t('Hierarchy chip'),
        what: t('Shows the rows of this table as a tree by the parent field (for example Parent).'),
        why: t('To see nested records in place.'),
        click: t('Point — the form; its menu switches Group ↔ Hierarchy; ⊗ — back to a flat list.'),
        affects: t('Only the layout of this table.'),
        stored: t('With this widget\'s settings in this tab; kept in the setting if you save the widget.'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Sort chip — AttrChips.vue:15
    'chips.chip.order': () => ({
        title: t('Sort chip'),
        what: t('Keeps the sort order of this table; it appears when you sort by a column header.'),
        why: t('The order survives re-reading the data.'),
        click: t('The chip text lists the sorted columns; ⊗ — back to the original order.'),
        affects: t('Only the row order of this table.'),
        stored: t('With this widget\'s settings in this tab; kept in the setting if you save the widget.'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Grouping chip — AttrChips.vue:15
    'chips.chip.group': () => ({
        title: t('Grouping chip'),
        what: t('Groups the rows of this table by the columns dragged onto the chip strip.'),
        why: t('To see the rows grouped by a column.'),
        click: t('Drag another column header onto the strip — add a level; the form menu switches Group ↔ Hierarchy; ⊗ — ungroup.'),
        affects: t('Only the layout of this table.'),
        stored: t('With this widget\'s settings in this tab; kept in the setting if you save the widget.'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Column filter chip — AttrChips.vue:15
    'chips.chip.grid-filter': () => ({
        title: t('Column filter chip'),
        what: t('Lists the columns filtered with the column filters in the table header.'),
        why: t('Reminds you that some rows are hidden by column filters.'),
        click: t('⊗ — clear these column filters.'),
        affects: t('Only this table.'),
        stored: t('With this widget\'s settings in this tab; kept in the setting if you save the widget.'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Current tree chip — AttrChips.vue:15
    'chips.chip.tree-root': () => ({
        title: t('Current tree chip'),
        what: t('The list shows only the current tree (it was opened for one tree).'),
        why: t('To work with one tree without the others.'),
        click: t('⊗ — show all trees (the list is re-read from the server).'),
        affects: t('Only this list.'),
        stored: t('With this widget\'s settings in this tab; kept in the setting if you save the widget.'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Tag chip — AttrChips.vue:15
    'chips.chip.tag': () => ({
        title: t('Tag chip'),
        what: t('Filters the list by a tag chosen in the tag bar above the table.'),
        why: t('Quick selection by labels.'),
        click: t('Click the tag in the tag bar again or ⊗ — remove the tag filter.'),
        affects: t('The list is rebuilt.'),
        stored: t('With this widget\'s settings in this tab; kept in the setting if you save the widget.'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Pages chip — AttrChips.vue:15
    'chips.chip.limit': () => ({
        title: t('Pages chip'),
        what: t('The list is loaded in pages: current page / number of pages (or the offset or data limit).'),
        why: t('Large lists open fast.'),
        click: t('‹ › — previous / next page (the data is re-read); ⊗ — reset paging.'),
        affects: t('In a list ⊗ loads all rows without a page limit; in the global search it returns to the default page size.'),
        stored: t('The page is part of the widget\'s data request; the page size comes from the widget settings.'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Corrections chip — AttrChips.vue:15
    'chips.chip.corrections': () => ({
        title: t('Corrections chip'),
        what: t('How many cells of this table you corrected and have not saved yet; the form lists them as «row · column: old → new».'),
        why: t('Keeps track of unsaved corrections.'),
        click: t('‹ › — go through the corrected cells; ⊗ — revert ALL unsaved corrections at once (Ctrl+Y brings them back).'),
        affects: t('Only this table; the chip disappears when nothing is left unsaved.'),
        stored: t('Not saved: exists while there are unsaved corrections.'),
        hotkey: t('Ctrl+Y — redo after ⊗'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Unsaved edits of the source chip — AttrChips.vue:15
    'chips.chip.unsaved-edits': () => ({
        title: t('Unsaved edits chip'),
        what: t('The table this breakdown is built from has unsaved edits in its source cells; the form lists them.'),
        why: t('Warns that the breakdown may differ from the saved data.'),
        click: t('⊗ — hide the chip; the edits stay in the source table.'),
        affects: t('Nothing else.'),
        stored: t('Not saved: shown while the source has unsaved edits.'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Information chip — AttrChips.vue:15
    'chips.chip.info': () => ({
        title: t('Information chip'),
        what: t('A summary from the report, for example metric counters or an approval summary; the form shows the details.'),
        why: t('Key figures at a glance.'),
        click: t('⊗ — hide it; if the chip comes from a report option, the option is switched off and the report re-read.'),
        affects: t('Switching an option off marks the report setting as changed.'),
        stored: t('Comes with the report data; the option itself is kept in the report setting.'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Regimen paused chip — AttrChips.vue:15 (IE 2026 10 10 / ODOO-345813, заказ Игоря: окна остановок регламента)
    'chips.chip.schedule-paused': () => ({
        title: t('Regimen paused chip'),
        what: t('A pause window of the regimen is in force: the scheduled tasks it covers are not started now. The chip names the end of the window and how many nodes of this workspace are held; the form lists the windows.'),
        why: t('So that nobody waits for a scheduled run that will not come.'),
        click: t('Nothing to click and no ⊗: the chip goes away by itself when the window ends or is resumed.'),
        affects: t('Nothing: it only shows the state; the windows are managed on the page «Schedule: pauses & backlog» of the Launchpad.'),
        stored: t('Not stored on the workspace: the server works it out from the active windows each time.'),
        setting: 'fe.ux.scheduleHeaderChip',
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Comparison chip — AttrChips.vue:15
    // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114897: плашка «Порівняння з» — _compare_info.compare_model): vars.what — с чем сравнивается отчёт сейчас, vars.reason — почему (строка бэка), где поменять — в «stored»
    'chips.chip.compare': (vars, ctx) => {
        const states = { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') }
        const reason = vars && vars.reason ? t('Chosen because {reason}.') : ''   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114897, проба p089d: причина выбора копии — словами, не кодом BE)   // сначала причина выбора копии, затем пояснение состояния (выделен / нет)
        return {
            title: t('Comparison chip'),
            what: vars && vars.what ? t('The report shows differences (Δ) from {what}; the badge is the number of rows with deviations.') : t('The report shows differences (Δ) from another process model or from the reference; the badge is the number of rows with deviations.'),
            why: t('See what changed between models.'),
            click: t('‹ › — go through the rows with deviations; ⊗ — switch the comparison off.'),
            affects: t('Switching off marks the report setting as changed and re-reads the report.'),
            stored: vars && vars.what ? t('The comparison mode is kept in the report setting: change it in the report form, tab «Comparison» — «Compare with» / «Model for comparison».') : t('The comparison mode is kept in the report setting.'),
            now: reason ? [reason, states[ctx && ctx.state]].filter(Boolean).join(' ') : '',
            states,
        }
    },
    // Process model chip — AttrChips.vue:15
    'chips.chip.process-model': () => ({
        title: t('Process model chip'),
        what: t('The report is calculated on the specified process model instead of the current one.'),
        why: t('Look at the same report on another model.'),
        click: t('Point — pick another model in the menu; ⊗ — back to the current model.'),
        affects: t('Every change marks the report setting as changed and re-reads the report.'),
        stored: t('In the report setting (kept when you save the report).'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Widget pages chip — AttrChips.vue:15
    'chips.chip.widgets-page': () => ({
        title: t('Widget pages chip'),
        what: t('A widget repeated for the rows of a list is shown in portions: shown range / total.'),
        why: t('Keeps the page light when there are many copies.'),
        click: t('‹ › — previous / next widgets; this chip has no form and cannot be removed.'),
        affects: t('Which copies are open on the page.'),
        stored: t('Not saved.'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Copied data chip — AttrChips.vue:15
    'chips.chip.copied': () => ({
        title: t('Copied data chip'),
        what: t('Rows, cells or filters copied from a table, for example for a chat or an editor; the badge is the number of copied rows.'),
        why: t('Carries a piece of a table as context.'),
        click: t('Point — the list of cells; Copy / Download in the form.'),
        affects: t('Nothing in the table.'),
        stored: t('Where it is pasted (chat, message, editor).'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Attachment chip — AttrChips.vue:15
    'chips.chip.object': () => ({
        title: t('Attachment chip'),
        what: t('A copied widget, record, JSON, picture or file added to the field.'),
        why: t('Carries an object as context, for example into a chat.'),
        click: t('Point — details; Download saves it as a file.'),
        affects: t('Nothing else.'),
        stored: t('Where it is pasted.'),
        states: { 'selected': t('Selected (outlined): Ctrl+C copies the chip, Ctrl+X cuts it, Alt+F1 opens its settings (table chips), Esc clears the selection.'), 'normal': t('Not selected — a click selects it.') },
    }),
    // Chip colour — AttrChips.vue:16
    'chips.chip-colour': () => ({
        title: t('Chip colour'),
        what: t('Yellow — unsaved corrections or edits; blue, orange or red — a colour given to the filter by the configuration; outlined — the selected chip; a blue line on the left — where a dragged chip will land.'),
        why: t('Tells chips apart at a glance.'),
        states: { 'unsaved': t('Yellow: unsaved corrections or edits.'), 'config': t('Colour set by the configuration of the filter.'), 'plain': t('Usual grey chip.') },
    }),
    // Chip icon — AttrChips.vue:296
    'chips.chip-icon': () => ({
        title: t('Chip icon'),
        what: t('Shows the kind of the chip; it turns into a gear while the pointer is on the chip.'),
        why: t('Leads to where the chip comes from or to its settings.'),
        click: t('Header: open the selector widget that set the filter (for the metrics chip — the metrics report). Table: open the chip settings next to it; a second click closes them.'),
        affects: t('Nothing changes until you edit something there.'),
        hotkey: t('Alt+F1 — the same for a selected table chip'),
        states: { 'header-widget': t('Opens the selector widget of this filter.'), 'header-none': t('This filter has no selector widget — nothing to open.'), 'metric-global': t('Opens the metrics report of the chip.'), 'mirror': t('Nothing to open: this is a copy of the header chip.'), 'table': t('Opens the settings of this chip.'), 'status': t('Nothing to open: this chip only reports a state.') },   // IE 2026 10 10 / ODOO-345813 (заказ Игоря: окна остановок регламента): + status — чипс шапки «Regimen paused until …» только сообщает о состоянии
    }),
    // Chip text — AttrChips.vue:300
    'chips.chip-text': () => ({
        title: t('Chip text'),
        what: t('The field and the selected values, or the search text; a long text is cut — the full one is in the form.'),
        why: t('Shows what the chip does without opening it.'),
        click: t('Double-click: in the header — open the selector widget of the filter; on a table search chip — edit the text.'),
        hotkey: t('Double-click'),
        states: { 'open': t('Double-click opens the selector widget.'), 'edit': t('Double-click edits the search text.'), 'none': t('Double-click does nothing here.'), 'status': t('Double-click does nothing: this chip only reports a state.') },   // IE 2026 10 10 / ODOO-345813: + status
    }),
    // Search text editor — AttrChips.vue:303
    'chips.chip-edit': () => ({
        title: t('Search text editor'),
        what: t('Edits the text of the search chip in place.'),
        click: t('Enter or leaving the field — apply the new text; an open chip settings window closes.'),
        affects: t('The table is filtered again.'),
        hotkey: t('Enter'),
    }),
    // Remove chip (⊗) — AttrChips.vue:367
    'chips.remove': (v, ctx) => ({
        title: t('Remove chip (⊗)'),
        what: t('Takes the chip off; header filters are only switched off, most table chips are deleted — see «Now».'),
        why: t('Undo a filter or a search quickly.'),
        click: t('Click — take the chip off; pointing here does not open the chip form.'),
        affects: t('The widgets concerned re-read or re-filter their data.'),
        stored: t('A switched-off header filter keeps its values in ⌄ Selectors — tick it to bring it back.'),
        // U4: Backspace в пустом поле поиска снимает только НАСТОЯЩИЙ чипс таблицы (removeLastChip после починки); у чипсов шапки поля ввода нет,
        // виртуальные (Corrections, Info, сравнение, процессная модель, пейджинг, зеркало метрик) Backspace не трогает
        hotkey: CHIPS_NO_BACKSPACE.includes(ctx && ctx.state) ? t('Ctrl+X on a selected chip') : t('Ctrl+X on a selected chip · Backspace in an empty search field'),
        states: { 'selector': t('Switches this workspace filter off; its values stay — tick it again in ⌄ Selectors.'), 'period': t('Switches the period off; it stays in ⌄ Selectors with its dates.'), 'metric-global': t('Switches the metrics chip off; its selection stays in ⌄ Selectors.'), 'metric-mirror': t('Hides this copy until the selection in the header changes; the header chip stays.'), 'filter': t('Switches the filter off; it stays in the widget settings but is no longer shown here.'), 'search': t('Deletes the chip.'), 'metric': t('Deletes the chip.'), 'format': t('Deletes the chip.'), 'style': t('Deletes the chip.'), 'tree': t('Deletes the chip.'), 'order': t('Deletes the chip.'), 'group': t('Deletes the chip.'), 'grid-filter': t('Deletes the chip and clears these column filters.'), 'copied': t('Deletes the chip.'), 'object': t('Deletes the chip.'), 'other': t('Deletes the chip.'), 'tree-root': t('Shows all trees again (the list is re-read).'), 'tag': t('Removes the tag filter and rebuilds the list.'), 'limit': t('Resets paging: a list loads all rows, the global search returns to its default page size.'), 'corrections': t('Reverts ALL unsaved corrections of this table at once (Ctrl+Y brings them back).'), 'unsaved-edits': t('Hides the chip; the edits stay in the source.'), 'info': t('Hides the chip; if it belongs to a report option, the option is switched off and the report re-read.'), 'compare': t('Switches the comparison off (the report setting is marked as changed and re-read).'), 'process-model': t('Returns the report to the current process model (the setting is marked as changed and the report re-read).') },
    }),
    // Input chip mark — AttrChips.vue:314
    'chips.badge.input': () => ({
        title: t('Input chip'),
        what: t('This chip restricts the selection on the server: the widget reads only the matching rows.'),
        why: t('The server also finds records by code or id and sees rows that are not loaded.'),
        click: t('Nothing to click; switch Table | Input in the chip form.'),
        affects: t('Any change of the chip makes the widget re-read its data.'),
        stored: t('The choice is kept in the chip (widget settings).'),
        setting: 'fe.ux.chipPlace',
    }),
    // Server warning mark — AttrChips.vue:315
    'chips.badge.notes': () => ({
        title: t('Server warning'),
        what: t('The server reported a problem with this input chip, for example it could not apply it; point at ⚠ for the text.'),
        why: t('So that you do not rely on a result the chip did not restrict.'),
        affects: t('The rows may not be restricted by this chip.'),
    }),
    // Values outside the calculation mark — AttrChips.vue:316
    'chips.badge.scope': () => ({
        title: t('Values outside the calculation'),
        what: t('Some selected values have no calculation documents in the current version — possibly a duplicate in the catalog.'),
        why: t('Explains why widgets filtered by this chip come out empty.'),
        affects: t('Widgets filtered by this chip show nothing for these values.'),
    }),
    // Copied cells count — AttrChips.vue:319
    'chips.badge.cells': () => ({
        title: t('Number of copied rows'),
        what: t('How many rows the copied data chip carries.'),
    }),
    // Approximate search mark (≈) — AttrChips.vue:332
    'chips.badge.fuzzy': () => ({
        title: t('Approximate search (≈)'),
        what: t('Nothing matched exactly, so the rows are found with typos allowed; such matches are highlighted differently.'),
        why: t('Finds names typed with a mistake or by dictation.'),
        affects: t('Only this search chip; changing its text resets the mode.'),
        states: { '1': t('Now: one vowel differs.'), '2': t('Now: one letter differs.'), '3': t('Now: up to two letters differ.'), '4': t('Now: some letters skipped.'), '5': t('Now: look-alike letters and symbols folded (№ ≈ Nº, Latin ≈ Cyrillic).'), '6': t('Now: several letters differ, the length may differ.'),
            '7': t('Now: extra symbol ignored.'), '8': t('Now: one extra letter or digit ignored.') },   // IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе): шаги последней ступени
        setting: 'fe.search.extraSymbolTier',   // IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе)
    }),
    // Whole phrase mark (“ ”) — AttrChips.vue:334
    'chips.badge.phrase': () => ({
        title: t('Whole phrase (“ ”)'),
        what: t('The words of this search were found together as a phrase, so they are not searched separately.'),
        why: t('For example «Impexpharm LLC» finds only that company, not every «LLC».'),
        affects: t('Filtering, highlighting and the counter use only the phrase; if the phrase is only in hidden rows, the search goes back to separate words.'),
        setting: 'fe.ux.searchPhraseFirst',
    }),
    // Other-language match mark — AttrChips.vue (IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках))
    'chips.badge.otherLang': () => ({
        title: t('Found in another language'),
        what: t('Nothing matched the displayed names, so the rows are found by the names of the same records in another language (link cells only); such cells get a dashed frame, the matched name is in the cell tooltip.'),
        why: t('Finds a record typed in English when the table shows Ukrainian names, and the other way round.'),
        affects: t('Only this search chip; changing its text resets the mode. Input chips are searched by the server in every language.'),
        setting: 'fe.ux.gridSearchOtherLangs',
        states: { 'en': t('Now: English names.'), 'uk': t('Now: Ukrainian names.'), 'ru': t('Now: names in other languages.'), 'other': t('Now: names in other languages.') },   // IE 2026 09 28 / ODOO-341407: русский язык не называется (было «Now: Russian names.»)
    }),
    // Other-language note in the chip form — AttrChips.vue
    'chips.form.other-lang': () => ({
        title: t('Found in another language'),
        what: t('Which language the matched names are in.'),
        setting: 'fe.ux.gridSearchOtherLangs',
    }),
    // Matches counter — AttrChips.vue:338
    // IE 2026 10 05 / ODOO-5800 (fe-86) (решение Игоря 05.10: «Показывать «1/1» с подсказкой «ещё 1 в выключенной опции»»): vars.more — готовая строка о ячейках сигнала в строках
    // выключенных опций отчёта (AttrChips.chipMore_vars → utils/metricChip.metricNav_moreText, хвост «+N» счётчика чипса метрик); дописывается к тексту состояния в
    // строке «Now» — и при «0», когда все ячейки сигнала лежат в выключенных опциях. Без неё запись прежняя
    'chips.badge.matches': (v, ctx) => {
        const states = { 'search': t('Counts cells with the text (at most 500).'), 'metric': t('Counts the most detailed matching cells; group totals are not counted. Until the first ‹ › click only their number is shown: › goes to the first cell, ‹ — to the last.'), 'format': t('Counts the cells painted by the selected rules.'), 'zero': t('Nothing found.') }   // IE 2026 10 05 / ODOO-5800 (fe-88): metric — счётчик до первого перехода ‹ ›
        const more = String((v && v.more) || '').trim()   // IE 2026 10 05 / ODOO-5800
        // IE 2026 10 05 / ODOO-5800 (fe-86) (наблюдение бота на бандле fe-85, dev02_check33: подсказка счётчика чипса метрик говорила «якщо збіг один, бейджа немає»): у чипса метрик
        // единственная остановка показывается с fe-82 («1», после клика «1/1»), до первого клика ‹ › — только число (fe-85), рядом может стоять хвост «+N» (fe-86) —
        // «What it is» у него своё. У поиска и чипса оформления правило прежнее (одно совпадение — бейджа нет). Вид чипса — vars.kind (при «0» состояние — zero)
        const metric = (v && v.kind === 'metric') || (ctx && ctx.state === 'metric')   // IE 2026 10 05 / ODOO-5800
        // IE 2026 10 05 / ODOO-5800 (fe-86, доработка по ревью: при fe.ux.metricNavHiddenHint = false текст обещал «+N», строка Setting называла настройку поиска): карточка чипса
        // метрик следует его выключателям — их значения приходят в vars (AttrChips.chipMore_vars: single / first / hidden; не переданы — включены), строка
        // Setting называет настройки счётчика чипса метрик
        const on = (k) => !v || v[k] !== false   // IE 2026 10 05 / ODOO-5800
        if (metric && !on('first')) states.metric = t('Counts the most detailed matching cells; group totals are not counted.')   // IE 2026 10 05 / ODOO-5800: без «до первого клика» (fe.ux.metricNavFirstStop = false)
        return {
            title: t('Matches counter'),
            what: metric
                ? [t('Current cell / number of cells the chip walks through in this table; 0 — nothing found.'), on('first') ? t('Until the first ‹ › click — only the number.') : '', on('single') ? t('A single cell is counted too («1», then «1/1»).') : t('There is no badge when there is exactly one cell.'), on('hidden') ? t('«+N» after the counter — N more cells are in rows of turned-off report options.') : ''].filter(Boolean).join(' ')   // IE 2026 10 05 / ODOO-5800
                : t('Current match / number of matches in this table; 0 — nothing found; there is no badge when there is exactly one.'),
            why: t('Shows how much was found and where you are.'),
            setting: metric ? 'fe.ux.metricNavSingle, fe.ux.metricNavFirstStop, fe.ux.metricNavHiddenHint, fe.data.metricCellNavMaxRows' : 'fe.grid.searchNavMaxRows',   // IE 2026 10 05 / ODOO-5800
            states,
            now: more ? [states[ctx && ctx.state], more].filter(Boolean).join(' ') : undefined,   // IE 2026 10 05 / ODOO-5800
        }
    },
    // Previous match — AttrChips.vue:340
    'chips.nav.matches.prev': () => ({
        title: t('Previous match'),
        what: t('Selects the previous match and scrolls to it (after the first — the last).'),
        why: t('Walk through what the chip found.'),
        click: t('Click — go to the previous match; a collapsed group opens for metrics and formatting matches.'),
        affects: t('Only the selection in the table.'),
    }),
    // Next match — AttrChips.vue:343
    'chips.nav.matches.next': () => ({
        title: t('Next match'),
        what: t('Selects the next match and scrolls to it (after the last — the first).'),
        why: t('Walk through what the chip found.'),
        click: t('Click — go to the next match; a collapsed group opens for metrics and formatting matches.'),
        affects: t('Only the selection in the table.'),
    }),
    // IE 2026 10 07 / ODOO-5800 (Igor 05.10: «когда чип поиска находит одно значение, то нужна кнопка ">»): Go to the only match — AttrChips.vue (ровно одно совпадение; при нескольких — пара ‹ › выше)
    'chips.nav.matches.go': () => ({
        title: t('Go to the match'),
        what: t('The chip found exactly one match: selects it and scrolls to it. With several matches this is a pair of arrows ‹ ›.'),
        why: t('The match can be far from the visible part — one click takes you to it.'),
        click: t('Click — go to the match; a collapsed group opens for it when needed.'),
        affects: t('Only the selection in the table.'),
        setting: 'fe.ux.chipNavSingleGo',
    }),
    // Count of an information chip — AttrChips.vue:352
    'chips.badge.info': () => ({
        title: t('Count'),
        what: t('Corrections chip — the number of corrected cells; comparison chip — the number of rows with deviations.'),
        states: { 'corrections': t('Corrected cells not saved yet.'), 'compare': t('Rows with deviations from the other model.'), 'info': t('A figure from the report.') },
    }),
    // Previous — AttrChips.vue:355
    'chips.nav.info.prev': () => ({
        title: t('Previous'),
        what: t('Corrections chip: the previous corrected cell; comparison chip: the previous row with deviations.'),
        why: t('Walk through the changes one by one.'),
        click: t('Click — select it and scroll to it.'),
        affects: t('Only the selection in the table.'),
        states: { 'corrections': t('Goes through the corrected cells.'), 'compare': t('Goes through the rows with deviations.'), 'info': t('Goes to the previous / next item.') },
    }),
    // Next — AttrChips.vue:356
    'chips.nav.info.next': () => ({
        title: t('Next'),
        what: t('Corrections chip: the next corrected cell; comparison chip: the next row with deviations.'),
        why: t('Walk through the changes one by one.'),
        click: t('Click — select it and scroll to it.'),
        affects: t('Only the selection in the table.'),
        states: { 'corrections': t('Goes through the corrected cells.'), 'compare': t('Goes through the rows with deviations.'), 'info': t('Goes to the previous / next item.') },
    }),
    // Widget pages range — AttrChips.vue:361
    'chips.badge.pages': () => ({
        title: t('Shown copies'),
        what: t('Which copies of the repeated widget are open: from–to / total.'),
    }),
    // Previous widgets — AttrChips.vue:362
    'chips.nav.pages.prev': () => ({
        title: t('Previous widgets'),
        what: t('Shows the previous portion of the repeated widget copies.'),
        click: t('Click — switch the portion.'),
        affects: t('Which copies are open on the page.'),
        stored: t('Not saved.'),
        states: { 'edge': t('This is the first portion.'), 'ok': t('Available.') },
    }),
    // Next widgets — AttrChips.vue:363
    'chips.nav.pages.next': () => ({
        title: t('Next widgets'),
        what: t('Shows the next portion of the repeated widget copies.'),
        click: t('Click — switch the portion.'),
        affects: t('Which copies are open on the page.'),
        stored: t('Not saved.'),
        states: { 'edge': t('This is the last portion.'), 'ok': t('Available.') },
    }),
    // Previous page — AttrChips.vue:323
    'chips.nav.limit.prev': () => ({
        title: t('Previous page'),
        what: t('Loads the previous page of the list.'),
        click: t('Click — the data is re-read for that page.'),
        affects: t('Only this list.'),
        states: { 'edge': t('No previous page.'), 'ok': t('Available.') },
    }),
    // Next page — AttrChips.vue:326
    'chips.nav.limit.next': () => ({
        title: t('Next page'),
        what: t('Loads the next page of the list.'),
        click: t('Click — the data is re-read for that page.'),
        affects: t('Only this list.'),
        states: { 'edge': t('No next page.'), 'ok': t('Available.') },
    }),
    // Chip form — AttrChips.vue:54
    'chips.form': () => ({
        title: t('Chip form'),
        what: t('Opens under the chip: the condition and values, value search, Recent, switches and Copy / Download.'),
        why: t('Change the chip without opening other windows.'),
        click: t('It stays open while the pointer is on the chip or the form, or while you type in its search field; point at a cut name to see it in full.'),
        setting: 'fe.ux.hoverOpenMs · fe.ux.hoverHideMs · fe.ux.chipClipTitles',
        hotkey: t('Esc in its search field — clear, then close'),
    }),
    // Condition of the chip — AttrChips.vue:119
    'chips.form.condition': () => ({
        title: t('Condition'),
        what: t('What the chip checks: the field, the operator and the values; for an information chip — its figures.'),
    }),
    // Chip type menu — AttrChips.vue:30
    'chips.form.type': () => ({
        title: t('Chip type'),
        what: t('Switches the chip between related kinds: Filter ↔ Selector, Group ↔ Hierarchy, Image ↔ File, the kinds of copied cells; the current one is bold.'),
        click: t('Click — change the kind; the chip is applied again.'),
        affects: t('How the chip filters or lays out the table.'),
        stored: t('In the chip (widget settings).'),
    }),
    // IE 2026 11 02 / ODOO-349799 (group-header-value): option «Field and count» of the grouping chip — AttrChips.vue (groupHeaderOption_toggle)
    'chips.form.groupHeader': () => ({
        title: t('Group header'),
        what: t('The header of a group row shows only the value by default; this option adds the field name and the number of items, as in «Field: value (N items)».'),
        click: t('Click — switch the option; the table is redrawn.'),
        affects: t('Hold Alt over a group row to see the field, the value, the number of items and the parent groups.'),
        stored: t('In the chip (widget settings).'),
    }),
    // Process model menu item — AttrChips.vue:40
    'chips.form.pm': () => ({
        title: t('Process model'),
        what: t('A model the report can be calculated on: the current one, the previous one or a specific one; the chosen one is bold.'),
        click: t('Click — calculate the report on that model.'),
        affects: t('Marks the report setting as changed and re-reads the report.'),
        stored: t('In the report setting once you save it.'),
    }),
    // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): папка «Archive (N)» в меню модели чипса и выбор модели сравнения в чипсе «Δ vs model» — AttrChips.vue (pmChipRows)
    'chips.form.pm.archive': () => ({
        title: t('Archive of the process model'),
        what: t('Daily archive copies of the model, taken at night: a truncated copy with the date of the previous day; the freshest is on top.'),
        click: t('Click — open or close the list of archives.'),
    }),
    'chips.form.compare.model': () => ({
        title: t('Model to compare with'),
        what: t('A model, What-if branch, snapshot or daily archive the report is compared with; the chosen one is bold.'),
        click: t('Click — compare the report with that model.'),
        affects: t('Marks the report setting as changed and re-reads the report.'),
        stored: t('In the report setting once you save it.'),
    }),
    'chips.form.compare.default': () => ({
        title: t('From settings'),
        what: t('Compare with the model set in the report, workspace or process model settings — as before a model was picked here; on the right — the model it resolves to.'),
        click: t('Click — return to the model from the settings.'),
        affects: t('Re-reads the report.'),
    }),
    // Period start — AttrChips.vue:51
    'chips.form.period.from': () => ({
        title: t('Period start'),
        what: t('The first day of the workspace period.'),
        why: t('Set the period without a chart.'),
        click: t('Pick a date — it is applied at once; if the start is later than the end, they are swapped.'),
        affects: t('Only the widgets that use the period re-read their data.'),
        stored: t('In the workspace chips (this tab and this browser).'),
    }),
    // Period end — AttrChips.vue:52
    'chips.form.period.to': () => ({
        title: t('Period end'),
        what: t('The last day of the workspace period.'),
        why: t('Set the period without a chart.'),
        click: t('Pick a date — it is applied at once; if the start is later than the end, they are swapped.'),
        affects: t('Only the widgets that use the period re-read their data.'),
        stored: t('In the workspace chips (this tab and this browser).'),
    }),
    // Metrics chip selection rule — AttrChips.vue:62
    'chips.form.metric.head': () => ({
        title: t('Selection rule'),
        what: t('How the lists combine: (Grade and Metric and Horizon and Status) or any exact combination; an empty list does not restrict.'),
        why: t('Explains why a row is or is not in the result.'),
    }),
    // Hint of the metrics chip copy — AttrChips.vue:64
    'chips.form.metric.mirror-hint': () => ({
        title: t('About this copy'),
        what: t('The chip belongs to the workspace header; the number is how many metrics of this table fall under the selection.'),
    }),
    // Hint of the workspace metrics chip — AttrChips.vue:66
    'chips.form.metric.global-hint': () => ({
        title: t('Workspace filter'),
        what: t('This chip filters the whole workspace: reports take only the calculation nodes that carry the selected metrics.'),
    }),
    // Value check box — AttrChips.vue:101
    'chips.form.value.check': () => ({
        title: t('Value check box'),
        what: t('One selected value of the filter; an unticked value stays in the list (grey) until the form is reopened.'),
        why: t('Remove or return one value without retyping.'),
        click: t('Click — remove / return the value (applied at once); Alt+click — keep only this value. Unticking the last value switches the filter off.'),
        affects: t('Widgets that take this field re-read their data.'),
        stored: t('Like the chip itself.'),
        hotkey: t('Alt+click — only this'),
        states: { 'on': t('In the filter.'), 'off': t('Removed; click to return.') },
    }),
    // Selected value — AttrChips.vue:97
    'chips.form.value.row': () => ({
        title: t('Selected value'),
        what: t('A value of the filter.'),
        click: t('Click the name — keep only this value.'),
        affects: t('Widgets that take this field re-read their data.'),
    }),
    // The only selected value — AttrChips.vue:113
    'chips.form.value.single': () => ({
        title: t('Selected value'),
        what: t('The only value of this filter, with an icon to open its record.'),
        click: t('Nothing to untick: to remove the value use ⊗, to change it — «Pick another value…».'),
    }),
    // Open the record of a value — AttrChips.vue:104
    'chips.form.open': () => ({
        title: t('Open the record'),
        what: t('The icon of the value\'s segment: opens the record of this value (object, country, subject…).'),
        why: t('Look at the value itself without leaving the filter.'),
        click: t('Click — the form closes and the record opens in a widget.'),
        affects: t('The filter does not change.'),
    }),
    // Selected metric value — AttrChips.vue:67
    'chips.form.metric.selected': () => ({
        title: t('Selected metric value'),
        what: t('What the chip selects now; the grey label says whether it is a Grade, Metric, Horizon, Status or a combination.'),
        click: t('Click the name — keep only this value.'),
        affects: t('Applied at once (in the header — after a short pause).'),
        states: { 'readonly': t('Read-only copy: change the selection in the header.'), 'edit': t('Editable.') },
    }),
    // Remove a metric value — AttrChips.vue:70
    'chips.form.metric.selected-check': () => ({
        title: t('Remove a value'),
        what: t('Every selected value is ticked; untick it to remove it from the chip.'),
        click: t('Click — remove this value; Alt+click — keep only this value.'),
        affects: t('Applied at once (in the header — after a short pause).'),
        hotkey: t('Alt+click — only this'),
        states: { 'readonly': t('Read-only copy: clicks do nothing here.'), 'edit': t('Click removes the value.') },
    }),
    // Selected formatting rule — AttrChips.vue:82
    'chips.form.format.selected': () => ({
        title: t('Selected formatting rule'),
        what: t('A rule the chip selects, with its colour sample.'),
        click: t('Click the name — keep only this rule.'),
        affects: t('Applied at once.'),
    }),
    // Remove a formatting rule — AttrChips.vue:85
    'chips.form.format.selected-check': () => ({
        title: t('Remove a rule'),
        what: t('Every selected rule is ticked; untick it to remove it from the chip.'),
        click: t('Click — remove this rule; Alt+click — keep only this rule.'),
        affects: t('Applied at once.'),
        hotkey: t('Alt+click — only this'),
    }),
    // Rule without Selector label — AttrChips.vue:88
    'chips.form.format.unknown': () => ({
        title: t('Rule no longer offered'),
        what: t('The rule is still in the chip, but it is no longer marked Selector (or was deleted), so it selects nothing.'),
        click: t('Untick it to clean the chip.'),
    }),
    // Colour sample — AttrChips.vue:70
    'chips.form.swatch': () => ({
        title: t('Colour sample'),
        what: t('The colour the rule paints cells with in this table.'),
    }),
    // Kind label — AttrChips.vue:73
    'chips.form.kind': () => ({
        title: t('Kind of value'),
        what: t('Grade, Metric, Horizon, Status or a combination (Grade + Metric + Reason …).'),
    }),
    // Nothing selected line — AttrChips.vue:75
    'chips.form.empty': () => ({
        title: t('Nothing selected'),
        what: t('The chip is empty and does not filter; tick values below to start.'),
    }),
    // Chip number — AttrChips.vue:122
    'chips.form.index': () => ({
        title: t('Chip number'),
        what: t('The position of the chip in the strip.'),
    }),
    // Copy chip — AttrChips.vue:123
    'chips.form.copy': () => ({
        title: t('Copy'),
        what: t('Copies the chip as text (JSON) to the clipboard.'),
        why: t('To paste the same chip into another table or into a chat.'),
        click: t('Click — copy; paste with Ctrl+V into a chip field.'),
        hotkey: t('Ctrl+C on a selected chip'),
    }),
    // Download chip — AttrChips.vue:124
    'chips.form.download': () => ({
        title: t('Download'),
        what: t('Saves the chip as a JSON file; a picture or file chip is saved as that file.'),
        click: t('Click — the browser saves the file.'),
    }),
    // Open the selector widget — AttrChips.vue:127
    'chips.form.open-selector': () => ({
        title: t('Open'),
        what: t('Opens the selector widget that set this filter; if the filter has none — the Selectors widget with all filters.'),
        why: t('Change the selection where it was made.'),
        click: t('Click — the widget opens, the form closes.'),
    }),
    // Open the metrics report — AttrChips.vue:131
    'chips.form.open-report': () => ({
        title: t('Open the metrics report'),
        what: t('Opens the report through which the metrics chip is resolved.'),
        why: t('See the metrics as a table and set the chip from it.'),
        click: t('Click — the report opens.'),
    }),
    // Show rows without matches — AttrChips.vue:135
    'chips.form.show-all-rows': () => ({
        title: t('Show rows without matches'),
        what: t('When ticked, rows without matches are not hidden: only highlighting, dimming and ‹ › remain.'),
        why: t('See the found rows in their context.'),
        click: t('Click — tick / untick; the table is re-filtered at once.'),
        affects: t('Only this table.'),
        stored: t('In the chip (widget settings); for the copy of the workspace chip — in this tab.'),
        setting: 'fe.ux.metricSelector',
        states: { 'on': t('Rows without matches are shown.'), 'off': t('Rows without matches are hidden.') },
    }),
    // Show other formatting — AttrChips.vue:140
    'chips.form.show-other-formats': () => ({
        title: t('Show other formatting'),
        what: t('When unticked, the table keeps the colouring only of the metrics or rules selected by this chip.'),
        why: t('Remove visual noise while you study one problem.'),
        click: t('Click — tick / untick; a table formatted on the server re-reads its data.'),
        affects: t('Colours of this table only.'),
        stored: t('In the chip (widget settings); for the copy of the workspace chip — in this tab.'),
        setting: 'fe.ux.metricSelector',
        states: { 'on': t('All formatting is shown.'), 'off': t('Only the formatting of this chip is shown.') },
    }),
    // Dim other formatting — AttrChips.vue (IE 2026 10 07 / ODOO-5800)
    'chips.form.dim-other-formats': () => ({
        title: t('Dim other formatting'),
        what: t('When ticked, coloured cells that this chip does not select are dimmed, so the selected ones stand out. Off by default.'),
        click: t('Click — tick / untick.'),
        affects: t('Colours of this table only.'),
        stored: t('In the chip (widget settings); for the copy of the workspace chip — in this tab.'),
        setting: 'fe.ux.metricChipDimFlag',
        states: { 'on': t('Other formatting is dimmed.'), 'off': t('Other formatting keeps its colours.') },
    }),
    // Acts on — AttrChips.vue:145
    'chips.form.place': () => ({
        title: t('Acts on'),
        what: t('Where the chip works: Table — on the rows already loaded; Input — the server restricts the selection.'),
        why: t('Input also finds rows that are not loaded and records by code or id.'),
        click: t('Choose Table or Input; the widget re-reads its data after a short pause.'),
        affects: t('Only this widget.'),
        stored: t('In the chip (widget settings); the default is not written.'),
        setting: 'fe.ux.chipPlace · fe.data.chipPlaceReloadMs',
        states: { 'table': t('Now: Table.'), 'input': t('Now: Input.') },
    }),
    // Acts on: Table — AttrChips.vue:147
    'chips.form.place.table': () => ({
        title: t('Table'),
        what: t('The chip works on the rows already loaded: it filters, highlights and navigates; the default for search chips.'),
        why: t('Instant and does not load the server.'),
        click: t('Click — switch the chip to Table; the widget re-reads its data once.'),
        affects: t('Only this widget.'),
        stored: t('In the chip (widget settings).'),
        setting: 'fe.ux.chipPlace',
        states: { 'current': t('Selected now.'), 'other': t('Click to switch.') },
    }),
    // Acts on: Input — AttrChips.vue:147
    'chips.form.place.input': () => ({
        title: t('Input'),
        what: t('The server restricts the selection: text is searched in text and link fields, conditions are added to the query; rows are not hidden in the browser. The default for filter chips.'),
        why: t('Finds rows that are not loaded, by code or id too.'),
        click: t('Click — switch the chip to Input; the widget re-reads its data.'),
        affects: t('Only this widget; every later change of the chip re-reads the data.'),
        stored: t('In the chip (widget settings).'),
        setting: 'fe.ux.chipPlace',
        states: { 'current': t('Selected now.'), 'other': t('Click to switch.') },
    }),
    // Server notes of an input chip — AttrChips.vue:152
    'chips.form.place.notes': () => ({
        title: t('Server notes'),
        what: t('Warnings of the server about this input chip, for example «Not applied on the server».'),
        affects: t('The rows may not be restricted by the chip.'),
    }),
    // Pick another value — AttrChips.vue:219
    'chips.form.pick.input': () => ({
        title: t('Pick another value'),
        what: t('Search among the values of this field: parts of names in any order, another keyboard layout, typos and numbers in words are understood; a selector chip offers the values its selector widget shows, and when none of them match — the matches from the whole catalog of the field, with a note above the list.'),   // IE 2026 09 30 / ODOO-5800: + расширенный поиск по подсегменту
        why: t('Change the filter without opening the selector widget.'),
        click: t('Type — up to 15 matches appear; Enter — take the first one as the only value; Esc — clear the text, then close the form.'),
        affects: t('Applied at once: widgets that take this field re-read their data.'),
        stored: t('Applied selections go to Recent (this browser).'),
        setting: 'fe.ux.chipPickOpenWidget · fe.ux.chipPickHiddenWidget · fe.ux.chipPickSubsegmentFallback · fe.ux.chipPickKeepsSelector',   // IE 2026 09 30 / ODOO-5800: + fe.ux.chipPickSubsegmentFallback   // IE 2026 10 13 / ODOO-5800: + fe.ux.chipPickKeepsSelector
        hotkey: t('Enter · Esc'),
    }),
    // Found value — AttrChips.vue:233
    'chips.form.pick.item': () => ({
        title: t('Found value'),
        what: t('A value found by the search; ticked ones are already in the filter; the parts matching your text are highlighted (approximate ones in yellow).'),
        click: t('Click the name — keep only this value (the form closes).'),
        affects: t('Widgets that take this field re-read their data.'),
    }),
    // Add / remove a found value — AttrChips.vue:237
    'chips.form.pick.check': () => ({
        title: t('Add / remove value'),
        what: t('Adds the value to the filter or removes it; the form stays open.'),
        click: t('Click — add / remove; Alt+click — keep only this value.'),
        affects: t('Widgets that take this field re-read their data.'),
        hotkey: t('Alt+click — only this'),
        states: { 'on': t('Already in the filter; click to remove.'), 'off': t('Not in the filter; click to add.') },
    }),
    // IE 2026 09 30 / ODOO-5800: Search widened line (no matches among the selector widget rows — the whole catalog of the facet's subsegment) — AttrChips.vue:247
    'chips.form.pick.wide': () => ({
        title: t('Search widened'),
        what: t('The selector widget, filtered by the other chips, has no values matching the text or only looser ones, so the list shows the same search over the whole catalog of this field without the other chips.'),
        click: t('Pick a value as usual — the chip takes it; together with the other chips the data may be empty.'),
        setting: 'fe.ux.chipPickSubsegmentFallback',
    }),
    // Search status line — AttrChips.vue:244
    'chips.form.pick.status': () => ({
        title: t('Search status'),
        what: t('Loading values, loading the selector widget, searching, or no matches.'),
    }),
    // Converted or approximate matches line — AttrChips.vue:248
    'chips.form.pick.conv': () => ({
        title: t('How the matches were found'),
        what: t('Nothing matched as typed: the list shows matches for the text converted to another keyboard layout, or approximate ones (the kind of typo is in brackets).'),
        states: { 'layout': t('Found in another keyboard layout.'), 'fuzzy': t('Found with typos allowed.'), 'both': t('Another layout and typos allowed.'),
            'extra': t('An extra symbol or character in the text was ignored.') },   // IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе): последняя ступень (шаг — в скобках подписи)
        setting: 'fe.search.extraSymbolTier',   // IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе)
    }),
    // Find a grade, metric or reason — AttrChips.vue:163
    'chips.form.metric.search': () => ({
        title: t('Find a metric'),
        what: t('Filters the lists below by words: every word must be in the name.'),
        why: t('Find the needed value in a long dictionary.'),
        click: t('Type words; Esc — clear, then close the form.'),
        affects: t('Only the lists in the form.'),
        hotkey: t('Esc'),
    }),
    // Metrics list heading — AttrChips.vue:171
    'chips.form.metric.group': () => ({
        title: t('List of values'),
        what: t('A list the chip selects from; the lists combine as (Grade and Metric and Horizon and Status) or any exact combination.'),
        states: { 'kinds': t('Kind: Problem, KPI or Info.'), 'signals': t('Signal: what happened — the short title of the problem, otherwise the name of the metric; one item selects every metric behind it.'), /* IE 2026 10 04 / ODOO-5800 (fe-74): секции чипса сигналов */ 'reasons': t('Cause: why it happened — a record of the Causes catalog.'), /* IE 2026 10 04 / ODOO-5800 (fe-78): секция причин */ 'grades': t('Grade: the severity of the case (for example Bad, Warning, Good).'), 'metrics': t('Metric: what is checked.'), 'horizons': t('Horizon: when it happens (past, planning window, future…); a metric valid for all horizons passes any.'), 'statuses': t('Status: the status of the document (autoplan, draft, confirmed, done); cases without a document do not pass a chosen status.'), 'combos': t('Exact combinations Grade + Metric + Reason (+ Horizon + Status): each works on its own («or»).') },
    }),
    // Metric value in the list — AttrChips.vue:172
    'chips.form.metric.item': () => ({
        title: t('Metric value'),
        what: t('A value from the dictionary with its colour sample and counter; ticked ones are in the chip.'),
        click: t('Click the name — make the chip select only this value.'),
        affects: t('Applied at once (in the header — after a short pause).'),
    }),
    // Add / remove a metric value — AttrChips.vue:177
    'chips.form.metric.check': () => ({
        title: t('Add / remove'),
        what: t('Adds the value to its list in the chip or removes it; the form stays open.'),
        click: t('Click — add / remove; Alt+click — keep only this value.'),
        affects: t('Applied at once (in the header — after a short pause).'),
        hotkey: t('Alt+click — only this'),
        states: { 'on': t('In the chip; click to remove.'), 'off': t('Not in the chip; click to add.') },
    }),
    // Metric value counter — AttrChips.vue:180
    'chips.form.metric.count': () => ({
        title: t('Counter'),
        what: t('How many cases this value covers now.'),
        states: { 'global-combos': t('Calculation nodes that carry this metric under the other workspace chips.'), 'global-other': t('Calculation nodes by the rules of this value; a node with two reasons counts twice.'), 'table-combos': t('Rows of the current selection under this rule.'), 'table-other': t('Hits of the rules; a row with two reasons counts twice.') },
    }),
    // Find a formatting rule — AttrChips.vue:192
    'chips.form.format.search': () => ({
        title: t('Find a rule'),
        what: t('Filters the rule list below by words: every word must be in the rule name.'),
        click: t('Type words; Esc — clear, then close the form.'),
        affects: t('Only the list in the form.'),
        hotkey: t('Esc'),
    }),
    // Formatting rules heading — AttrChips.vue:199
    'chips.form.format.group': () => ({
        title: t('Rules with Selector'),
        what: t('Only the conditional formatting rules marked Selector are offered; mark more rules in the Conditional format grid.'),
    }),
    // Formatting rule in the list — AttrChips.vue:200
    'chips.form.format.item': () => ({
        title: t('Formatting rule'),
        what: t('A rule with its colour sample and counters rows · cells; ticked ones are in the chip.'),
        click: t('Click the name — make the chip select only this rule.'),
        affects: t('Applied at once.'),
    }),
    // Add / remove a formatting rule — AttrChips.vue:205
    'chips.form.format.check': () => ({
        title: t('Add / remove a rule'),
        what: t('Adds the rule to the chip or removes it; the form stays open.'),
        click: t('Click — add / remove; Alt+click — keep only this rule.'),
        affects: t('Applied at once.'),
        hotkey: t('Alt+click — only this'),
        states: { 'on': t('In the chip; click to remove.'), 'off': t('Not in the chip; click to add.') },
    }),
    // Formatting rule counter — AttrChips.vue:208
    'chips.form.format.count': () => ({
        title: t('Rows · cells'),
        what: t('How many rows and cells of the current selection this rule paints.'),
    }),
    // Recent selections — AttrChips.vue:278
    'chips.form.recent': () => ({
        title: t('Recent'),
        what: t('Your latest selections of this field (or of this chip), newest first; the ticked one is applied now.'),
        why: t('Return to a previous selection in one click.'),
        click: t('Click a line — apply it; tick — add its values to the current selection.'),
        affects: t('Applied at once.'),
        stored: t('In this browser, for you; the field history is shared by all workspaces of this database.'),
    }),
    // Recent selection (selector) — AttrChips.vue:280
    'chips.form.recent.selector.item': () => ({
        title: t('Recent selection'),
        what: t('A previous selection; the ticked line is the one applied now.'),
        click: t('Click the name or Alt+click the box — apply this selection instead of the current one.'),
        affects: t('Applied at once.'),
        stored: t('In this browser (per field, shared by the workspaces of this database).'),
        setting: 'fe.ux.chipPickKeepsSelector',   // IE 2026 10 13 / ODOO-5800: выбор из Recent оставляет чипс селектором (значение — списком в attrs строки стола)
    }),
    // Add a recent selection (selector) — AttrChips.vue:286
    'chips.form.recent.selector.check': () => ({
        title: t('Add to the selection'),
        what: t('Adds the values of this recent selection to the current one.'),
        click: t('Click — add; Alt+click — apply it instead of the current one.'),
        affects: t('Applied at once.'),
        stored: t('In this browser (per field, shared by the workspaces of this database).'),
        hotkey: t('Alt+click — replace'),
        states: { 'current': t('This selection is applied now.'), 'other': t('Click to add its values.') },
    }),
    // Recent selection (metric) — AttrChips.vue:257
    'chips.form.recent.metric.item': () => ({
        title: t('Recent selection'),
        what: t('A previous selection; the ticked line is the one applied now.'),
        click: t('Click the name or Alt+click the box — apply this selection instead of the current one.'),
        affects: t('Applied at once.'),
        stored: t('In this browser (per widget; in the header — per workspace).'),
    }),
    // Add a recent selection (metric) — AttrChips.vue:262
    'chips.form.recent.metric.check': () => ({
        title: t('Add to the selection'),
        what: t('Adds the values of this recent selection to the current one.'),
        click: t('Click — add; Alt+click — apply it instead of the current one.'),
        affects: t('Applied at once.'),
        stored: t('In this browser (per widget; in the header — per workspace).'),
        hotkey: t('Alt+click — replace'),
        states: { 'current': t('This selection is applied now.'), 'other': t('Click to add its values.') },
    }),
    // Recent selection (format) — AttrChips.vue:269
    'chips.form.recent.format.item': () => ({
        title: t('Recent selection'),
        what: t('A previous selection; the ticked line is the one applied now.'),
        click: t('Click the name or Alt+click the box — apply this selection instead of the current one.'),
        affects: t('Applied at once.'),
        stored: t('In this browser (per widget).'),
    }),
    // Add a recent selection (format) — AttrChips.vue:274
    'chips.form.recent.format.check': () => ({
        title: t('Add to the selection'),
        what: t('Adds the values of this recent selection to the current one.'),
        click: t('Click — add; Alt+click — apply it instead of the current one.'),
        affects: t('Applied at once.'),
        stored: t('In this browser (per widget).'),
        hotkey: t('Alt+click — replace'),
        states: { 'current': t('This selection is applied now.'), 'other': t('Click to add its values.') },
    }),
    // Chip list panel — AttrChips.vue:393
    'chips.dd.panel': () => ({
        title: t('Chip list'),
        what: t('The panel of the ⌄ button: chips, parameters and commands of this strip in columns.'),
        click: t('A click outside the panel closes it.'),
    }),
    // Selectors tab — AttrChips.vue:395
    'chips.dd.tab.selectors': () => ({
        title: t('Selectors'),
        what: t('All workspace filters, including switched-off ones, with on/off boxes; also «Metrics» to add the metrics chip.'),
        why: t('Bring back a switched-off filter or add the metrics chip.'),
        click: t('Click the heading — open the Selectors widget with all filters as a table.'),
    }),
    // Params tab — AttrChips.vue:395
    'chips.dd.tab.params': () => ({
        title: t('Params'),
        what: t('Parameters: in the header — of the workspace, above a table — of the widget; shown for reference.'),
        click: t('Above a table: click the heading — open the widget\'s parameters.'),
        states: { 'table': t('The heading opens the widget\'s parameters.'), 'page': t('For reference; parameters are changed in the settings.') },
    }),
    // Commands tab — AttrChips.vue:395
    'chips.dd.tab.commands': () => ({
        title: t('Commands'),
        what: t('Saved variants of the workspace filters and of this page, with commands to save them, and page commands.'),
        why: t('Manage what opens and how.'),
    }),
    // Chips tab (table) — AttrChips.vue:395
    'chips.dd.tab.chips': () => ({
        title: t('Chips'),
        what: t('Ready-made chips this table offers: Parent (tree view), Metrics, Formats; empty when none applies.'),
        click: t('Click an item — add the chip.'),
    }),
    // Filters tab (Selectors widget) — AttrChips.vue:395
    'chips.dd.tab.filters': () => ({
        title: t('Filters'),
        what: t('Filter chips of this widget with on/off boxes.'),
        click: t('Click the heading — open the Selectors widget.'),
    }),
    // Add tab (search, editors) — AttrChips.vue:395
    'chips.dd.tab.add': () => ({
        title: t('Add'),
        what: t('Templates of chips to add, for example a Filter.'),
        click: t('Click a template — add the chip and open its settings.'),
    }),
    // Add chip button of a tab — AttrChips.vue:400
    'chips.dd.tab.plus': () => ({
        title: t('Add a chip'),
        what: t('Adds an empty filter chip and opens its settings.'),
        click: t('Click — add.'),
    }),
    // Filter on / off box — AttrChips.vue:467
    'chips.dd.item.check': () => ({
        title: t('On / off'),
        what: t('Switches the filter on or off without losing its values.'),
        why: t('Temporarily drop a filter and bring it back.'),
        click: t('Click — switch; the widgets re-read at once.'),
        affects: t('Widgets that take this field.'),
        stored: t('Header: only for you, like the workspace chips.'),
        states: { 'on': t('On: the filter applies.'), 'off': t('Off: the filter keeps its values but does not apply.') },
    }),
    // Filter in the list — AttrChips.vue:460
    'chips.dd.item.filter': () => ({
        title: t('Filter'),
        what: t('A workspace filter; switched-off filters are listed here too.'),
        click: t('Header: click the name — open its selector widget (the Selectors widget if it has none).'),
        states: { 'page': t('The name opens the selector widget.'), 'other': t('Use the box to switch it.') },
    }),
    // Metrics chip in the list — AttrChips.vue:460
    'chips.dd.item.metric': () => ({
        title: t('Metrics chip'),
        what: t('The workspace metrics chip.'),
        click: t('Switched off — click to switch it on; switched on — click to open its form.'),
        states: { 'on': t('On — click opens its form.'), 'off': t('Off — click switches it on.') },
    }),
    // Ready-made chip to add — AttrChips.vue:460
    'chips.dd.template': () => ({
        title: t('Add a chip'),
        what: t('A ready-made chip to add; see «Now» for what it does.'),
        click: t('Click — add it (Metrics and Formats open their form at once).'),
        affects: t('Only this strip.'),
        states: { 'metric': t('Metrics: adds a metrics chip and opens its form; in the header it is offered only when the workspace knows a metrics report.'), 'tree': t('Parent: shows the rows as a tree by the Parent field.'), 'format': t('Formats: adds a formatting chip and opens its form; offered when some formatting rules are marked Selector.'), 'filter': t('Adds an empty filter and opens its settings.') },
    }),
    // Parameter in the list — AttrChips.vue:460
    'chips.dd.param': () => ({
        title: t('Parameter'),
        what: t('A parameter and its value, for reference.'),
        click: t('Click — the list closes; parameters are changed in the settings.'),
    }),
    // Other chip in the list — AttrChips.vue:460
    'chips.dd.item.other': () => ({
        title: t('Chip'),
        what: t('A chip of this strip.'),
        click: t('Click — the list closes.'),
    }),
    // Nested item of a group — AttrChips.vue:445
    'chips.dd.nested': () => ({
        title: t('Item'),
        what: t('An item of the group.'),
        click: t('Click — run it.'),
    }),
    // Divider — AttrChips.vue:426
    'chips.dd.divider': () => ({
        title: t('Divider'),
        what: t('Separates items.'),
    }),
    // Variant list heading (legacy) — AttrChips.vue:428
    'chips.dd.variant-head': () => ({
        title: t('Variants'),
        what: t('Heading of a list of variants with the All · Me columns.'),
    }),
    // Commands group heading — AttrChips.vue:411
    'chips.cmd.group': () => ({
        title: t('Group of variants'),
        what: t('Filters — saved sets of workspace chips; Page — saved sets of open widgets and their layout, plus page commands. The buttons in the heading act on this group.'),
        why: t('Switch between prepared views in one click.'),
        click: t('Click a row to apply it; hold Alt over a button to see what it does.'),
        states: { 'filters': t('Filters: saved sets of workspace chips.'), 'page': t('Page: saved widget layouts of this page and page commands.') },
    }),
    // All · Me columns — AttrChips.vue:422
    'chips.cmd.cols': () => ({
        title: t('All · Me'),
        what: t('Two columns of check boxes: default for all users (admins only) and default for me; «for me» wins over «for all».'),
        why: t('Decide what opens first when the workspace or the page is opened.'),
        click: t('Tick a box in a row to make that row the default.'),
        affects: t('What you (Me) or everyone (All) get the next time the workspace / page opens.'),
        stored: t('On the server: «for all» — in the workspace or page record, «for me» — in your user settings.'),
    }),
    // Variant row — AttrChips.vue:431
    'chips.cmd.row': () => ({
        title: t('Variant'),
        what: t('A saved variant; «(main)» is the workspace\'s own filters or the page\'s own widgets. The current one is bold with the Current badge.'),
        why: t('Switch to a prepared set of filters or widgets.'),
        click: t('Click — apply: a filters variant replaces the workspace chips at once; a page variant reopens the page with its widgets.'),
        affects: t('Filters: all widgets re-read under the new chips. Page: the page widgets are closed WITHOUT asking to save their changes and opened from the variant.'),
        stored: t('The choice lasts for this session; to open it by default, tick Me (or All).'),
        states: { 'filters-main': t('The workspace\'s own filters.'), 'filters-variant': t('A saved filters variant; a private one is visible only to its owner (see the tooltip).'), 'page-main': t('The page\'s own widgets.'), 'page-variant': t('A saved widget layout of this page; it opens under the same page and menu.') },
    }),
    // Variant kind icon — AttrChips.vue:433
    'chips.cmd.row-icon': () => ({
        title: t('Kind'),
        what: t('Funnel — a filters variant; screen — a page variant.'),
    }),
    // Current badge — AttrChips.vue:435
    'chips.cmd.current': () => ({
        title: t('Current'),
        what: t('This row is applied now.'),
        click: t('Click the row again — apply it anew.'),
    }),
    // Delete variant — AttrChips.vue:439
    'chips.cmd.delete': () => ({
        title: t('Delete variant'),
        what: t('Moves the variant to the archive after a confirmation; the main filters / page stay as they are.'),
        why: t('Clean up variants you no longer need.'),
        click: t('Click — confirm; if the variant was applied, the main one is applied instead.'),
        affects: t('The variant disappears for everyone; its «default» marks are removed.'),
        stored: t('On the server: the record is archived and can be restored from the archive.'),
    }),
    // Default for all — AttrChips.vue:440
    'chips.cmd.all': () => ({
        title: t('Default for all'),
        what: t('Opens this variant for every user of the workspace (unless someone chose «for me»); only admins can change it.'),
        why: t('Give everyone the same starting view.'),
        click: t('Click — set / clear; on «(main)» — make the main filters / page the default for all again.'),
        affects: t('What all users get the next time they open the workspace / page.'),
        stored: t('On the server, in the workspace record (filters) or the page record (page variants) — shared.'),
        states: { 'locked': t('Only admins can change it.'), 'main-on': t('No variant is the default for all — everyone gets the main one.'), 'main-off': t('A variant is the default for all; click — return to the main one.'), 'variant-on': t('This variant opens for everyone; click — clear.'), 'variant-off': t('Click — make it the default for everyone (a private variant cannot be).') },
    }),
    // Default for me — AttrChips.vue:442
    'chips.cmd.me': () => ({
        title: t('Default for me'),
        what: t('Opens this variant for you; it wins over «for all».'),
        why: t('Keep your own starting view without affecting others.'),
        click: t('Click — set / clear; on «(main)» — use the main one for you again.'),
        affects: t('Only what you get next time.'),
        stored: t('On the server, in your user settings.'),
        states: { 'main-on': t('You have no personal default — you get the main one (or the one for all).'), 'main-off': t('You have a personal default variant; click — drop it.'), 'variant-on': t('Opens for you; click — clear.'), 'variant-off': t('Click — make it your default.') },
    }),
    // Separator of command buttons — AttrChips.vue:415
    'chips.cmd.gap': () => ({
        title: t('Separator'),
        what: t('Variant buttons on the left, page commands on the right.'),
    }),
    // Save as new variant (filters) — AttrChips.vue:416
    'chips.cmd.btn.filters-new': () => ({
        title: t('Save as new variant (filters)'),
        what: t('Saves the current workspace chips as a new filters variant — private, visible only to you — and makes it your default.'),
        why: t('Keep a set of filters to come back to.'),
        click: t('Click — enter a title; the new variant becomes current.'),
        affects: t('Next time the workspace opens with this variant for you.'),
        stored: t('On the server: a new private Filters record and your «default for me».'),
    }),
    // Save (filters) — AttrChips.vue:416
    'chips.cmd.btn.filters-save': () => ({
        title: t('Save (filters)'),
        what: t('Writes the current chips into the current filters variant; with no variant applied — into the workspace itself (admins only).'),
        why: t('Update a saved set after changing chips.'),
        click: t('Click — saved at once, without questions; only the owner of the variant or an admin can save into it.'),
        affects: t('Everyone who opens this variant — or, for the workspace itself, every user of the workspace — gets these chips.'),
        stored: t('On the server: the variant or the workspace record (shared); your local snapshot of the chips is dropped.'),
        states: { 'variant': t('Saves into the current variant.'), 'workspace': t('No variant applied: saves into the workspace itself — for everyone (admins only).') },
    }),
    // Save as new variant (page) — AttrChips.vue:416
    'chips.cmd.btn.page-new': (v, ctx) => (ctx?.state === 'temp') ? tempPageHelp('new') : ({   // IE 2026 09 26 / ODOO-…: temp — временная страница
        title: t('Save as new variant (page)'),
        what: t('Saves the open widgets and their layout as a new variant of this page — private — and makes it your default for this page.'),
        why: t('Keep a layout of widgets to come back to.'),
        click: t('Click — enter a title; the new variant becomes current.'),
        affects: t('Next time this page opens with these widgets for you; the page and its menu stay the same.'),
        stored: t('On the server: a new Page record (a variant of this page) and your «default for me».'),
    }),
    // Save (page) — AttrChips.vue:416
    'chips.cmd.btn.page-save': (v, ctx) => (ctx?.state === 'temp') ? tempPageHelp('save') : ({   // IE 2026 09 26 / ODOO-…: temp — временная страница
        title: t('Save (page)'),
        what: t('Writes the open widgets and their layout into the current page variant; with no variant applied — into the page itself (admins only).'),
        why: t('Update a saved layout.'),
        click: t('Click — saved at once; only the owner of the variant or an admin can save into it.'),
        affects: t('Everyone who opens this variant — or, for the page itself, every user — gets this layout.'),
        stored: t('On the server: the variant or the page record (shared).'),
        states: { 'variant': t('Saves into the current page variant.'), 'page': t('No variant applied: saves into the page itself — for everyone (admins only).') },
    }),
    // Page settings — AttrChips.vue:416
    'chips.cmd.btn.page-settings': (v, ctx) => (ctx?.state === 'temp') ? tempPageHelp('settings') : ({   // IE 2026 09 26 / ODOO-…: temp — временная страница
        title: t('Page settings'),
        what: t('Opens the record of the current page: title, icon, widget list and layout.'),
        why: t('Change the page itself.'),
        click: t('Click — the record opens in a widget.'),
        affects: t('Saved changes apply to the page for all its users.'),
        stored: t('On the server, in the page record, when you save it.'),
    }),
    // Save as new page — AttrChips.vue:416
    'chips.cmd.btn.page-copy': (v, ctx) => (ctx?.state === 'temp') ? tempPageHelp('copy') : ({   // IE 2026 09 26 / ODOO-…: temp — временная страница
        title: t('Save as new page'),
        what: t('Saves what is open on this page as a new page of the workspace (widgets and layout as they are).'),
        why: t('Start a new page from the current one.'),
        click: t('Click — enter a title; the new page is added after the current one and opens.'),
        affects: t('The new page appears in the page list of the workspace for all its users.'),
        stored: t('On the server: a new Page record and the updated workspace record.'),
    }),
    // Make this my start workspace — AttrChips.vue:416
    'chips.cmd.btn.start-workspace': () => ({
        title: t('Make this my start workspace'),
        what: t('After login this workspace opens first — for you only.'),
        why: t('Start where you usually work.'),
        click: t('Click — saved at once.'),
        affects: t('Only your next logins.'),
        stored: t('On the server, in your user settings.'),
    }),
    // Save as my (filters) — AttrChips.vue:416
    'chips.cmd.btn.legacy-filters-my': () => ({
        title: t('Save as my (filters)'),
        what: t('Saves the current chips as your defaults of this workspace.'),
        click: t('Click — saved at once.'),
        affects: t('Only you: the workspace opens with these chips next time.'),
        stored: t('On the server, in your user settings.'),
    }),
    // Save for all (filters) — AttrChips.vue:416
    'chips.cmd.btn.legacy-filters-all': () => ({
        title: t('Save for all (filters)'),
        what: t('Saves the current chips as the defaults of this workspace for everyone (admins).'),
        click: t('Click — saved at once.'),
        affects: t('All users of the workspace get these chips by default.'),
        stored: t('On the server, in the workspace record (shared).'),
    }),
    // Use defaults (filters) — AttrChips.vue:416
    'chips.cmd.btn.legacy-filters-reset': () => ({
        title: t('Use defaults (filters)'),
        what: t('Drops your default chips and returns the workspace default filters.'),
        click: t('Click — the workspace reopens with its default filters.'),
        affects: t('Only you.'),
        stored: t('Your saved defaults and the local snapshot are removed.'),
    }),
    // Save as my (page) — AttrChips.vue:416
    'chips.cmd.btn.legacy-page-my': () => ({
        title: t('Save as my (page)'),
        what: t('Saves the open widgets and their layout as your defaults of this page.'),
        click: t('Click — saved at once.'),
        affects: t('Only you.'),
        stored: t('On the server, in your user settings.'),
    }),
    // Save for all (page) — AttrChips.vue:416
    'chips.cmd.btn.legacy-page-all': () => ({
        title: t('Save for all (page)'),
        what: t('Saves the open widgets and their layout as the defaults of this page for everyone (admins).'),
        click: t('Click — saved at once.'),
        affects: t('All users of the page.'),
        stored: t('On the server, in the page record (shared).'),
    }),
    // Use defaults (page) — AttrChips.vue:416
    'chips.cmd.btn.legacy-page-reset': () => ({
        title: t('Use defaults (page)'),
        what: t('Drops your widget defaults of this page.'),
        click: t('Click — removed at once; the page opens with its defaults next time.'),
        affects: t('Only you.'),
        stored: t('Your saved defaults are removed on the server.'),
    }),
    // Command button — AttrChips.vue:416
    'chips.cmd.btn': () => ({
        title: t('Command'),
        what: t('A command of this group; hold Alt to see its name and what it does.'),
        click: t('Click — run it.'),
    }),
}

export default chips
